"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConstraintConverterResolver_1 = require("./ConstraintConverterResolver");

var ConstraintSettingsConverter_1 = require("./ConstraintSettingsConverter");

var ConstraintSettings_1 = require("../../model/constraint/ConstraintSettings");

var ConstraintTypeEnum_1 = require("../../model/constraint/ConstraintTypeEnum");

var typescript_ioc_1 = require("@logio/typescript-ioc");
/**
 * Default implementation of {@link ConstraintSettingsConverter}.
 *
 * @author RV
 */


var ConstraintSettingsConverterImpl =
/*#__PURE__*/
function (_ConstraintSettingsCo) {
  _inherits(ConstraintSettingsConverterImpl, _ConstraintSettingsCo);

  function ConstraintSettingsConverterImpl(constraintConverterResolver) {
    var _this;

    _classCallCheck(this, ConstraintSettingsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConstraintSettingsConverterImpl).call(this));
    _this.constraintConverterResolver = constraintConverterResolver;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ConstraintSettingsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ConstraintSettings_1.ConstraintSettings(conversions.asObjectList(source, 'constraints', function (constraintDocument) {
        return _this2.constraintConverterResolver.resolve(conversions.asEnum(constraintDocument.constraintType, ConstraintTypeEnum_1.ConstraintTypeEnum)).toObject(constraintDocument, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        constraints: conversions.asObjectArray(source, 'constraints', function (constraint) {
          return _this3.constraintConverterResolver.resolve(constraint.getType()).toDocument(constraint, conversions);
        })
      });
      return result;
    }
  }]);

  return ConstraintSettingsConverterImpl;
}(ConstraintSettingsConverter_1.ConstraintSettingsConverter);

ConstraintSettingsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ConstraintConverterResolver_1.ConstraintConverterResolver])], ConstraintSettingsConverterImpl);
exports.ConstraintSettingsConverterImpl = ConstraintSettingsConverterImpl;